import asyncActionType from "../../utils/asyncActionType";

// Dashboard
export const FETCH_DASHBOARD = asyncActionType("FETCH_MAINTENANCE_DASHBOARD");
export const FETCH_UPCOMING_MAINTENANCE = asyncActionType("FETCH_UPCOMING_MAINTENANCE");
export const FETCH_OVERDUE_MAINTENANCE = asyncActionType("FETCH_OVERDUE_MAINTENANCE");

// Machine Types
export const FETCH_MACHINE_TYPES = asyncActionType("FETCH_MACHINE_TYPES");
export const FETCH_MACHINE_TYPE = asyncActionType("FETCH_MACHINE_TYPE");
export const CREATE_MACHINE_TYPE = asyncActionType("CREATE_MACHINE_TYPE");
export const UPDATE_MACHINE_TYPE = asyncActionType("UPDATE_MACHINE_TYPE");
export const DELETE_MACHINE_TYPE = asyncActionType("DELETE_MACHINE_TYPE");

// Facility Types
export const FETCH_FACILITY_TYPES = asyncActionType("FETCH_FACILITY_TYPES");
export const FETCH_FACILITY_TYPE = asyncActionType("FETCH_FACILITY_TYPE");
export const CREATE_FACILITY_TYPE = asyncActionType("CREATE_FACILITY_TYPE");
export const UPDATE_FACILITY_TYPE = asyncActionType("UPDATE_FACILITY_TYPE");
export const DELETE_FACILITY_TYPE = asyncActionType("DELETE_FACILITY_TYPE");

// Locations
export const FETCH_MAINTENANCE_LOCATIONS = asyncActionType("FETCH_MAINTENANCE_LOCATIONS");
export const FETCH_MAINTENANCE_LOCATION = asyncActionType("FETCH_MAINTENANCE_LOCATION");
export const CREATE_MAINTENANCE_LOCATION = asyncActionType("CREATE_MAINTENANCE_LOCATION");
export const UPDATE_MAINTENANCE_LOCATION = asyncActionType("UPDATE_MAINTENANCE_LOCATION");
export const DELETE_MAINTENANCE_LOCATION = asyncActionType("DELETE_MAINTENANCE_LOCATION");

// Service Providers
export const FETCH_SERVICE_PROVIDERS = asyncActionType("FETCH_SERVICE_PROVIDERS");
export const FETCH_SERVICE_PROVIDER = asyncActionType("FETCH_SERVICE_PROVIDER");
export const CREATE_SERVICE_PROVIDER = asyncActionType("CREATE_SERVICE_PROVIDER");
export const UPDATE_SERVICE_PROVIDER = asyncActionType("UPDATE_SERVICE_PROVIDER");
export const DELETE_SERVICE_PROVIDER = asyncActionType("DELETE_SERVICE_PROVIDER");

// Machines
export const FETCH_MACHINES = asyncActionType("FETCH_MACHINES");
export const FETCH_MACHINE = asyncActionType("FETCH_MACHINE");
export const CREATE_MACHINE = asyncActionType("CREATE_MACHINE");
export const UPDATE_MACHINE = asyncActionType("UPDATE_MACHINE");
export const DELETE_MACHINE = asyncActionType("DELETE_MACHINE");
export const START_MACHINE_MAINTENANCE = asyncActionType("START_MACHINE_MAINTENANCE");
export const FETCH_MACHINE_MAINTENANCE_HISTORY = asyncActionType("FETCH_MACHINE_MAINTENANCE_HISTORY");

// Facilities
export const FETCH_FACILITIES = asyncActionType("FETCH_FACILITIES");
export const FETCH_FACILITY = asyncActionType("FETCH_FACILITY");
export const CREATE_FACILITY = asyncActionType("CREATE_FACILITY");
export const UPDATE_FACILITY = asyncActionType("UPDATE_FACILITY");
export const DELETE_FACILITY = asyncActionType("DELETE_FACILITY");
export const FETCH_FACILITY_TASKS = asyncActionType("FETCH_FACILITY_TASKS");

// Task Templates
export const FETCH_TASK_TEMPLATES = asyncActionType("FETCH_TASK_TEMPLATES");
export const FETCH_TASK_TEMPLATE = asyncActionType("FETCH_TASK_TEMPLATE");
export const CREATE_TASK_TEMPLATE = asyncActionType("CREATE_TASK_TEMPLATE");
export const UPDATE_TASK_TEMPLATE = asyncActionType("UPDATE_TASK_TEMPLATE");
export const DELETE_TASK_TEMPLATE = asyncActionType("DELETE_TASK_TEMPLATE");

// Task Assignments
export const FETCH_TASK_ASSIGNMENTS = asyncActionType("FETCH_TASK_ASSIGNMENTS");
export const FETCH_TASK_ASSIGNMENT = asyncActionType("FETCH_TASK_ASSIGNMENT");
export const CREATE_TASK_ASSIGNMENT = asyncActionType("CREATE_TASK_ASSIGNMENT");
export const UPDATE_TASK_ASSIGNMENT = asyncActionType("UPDATE_TASK_ASSIGNMENT");
export const DELETE_TASK_ASSIGNMENT = asyncActionType("DELETE_TASK_ASSIGNMENT");
export const GENERATE_ASSIGNMENT_TASKS = asyncActionType("GENERATE_ASSIGNMENT_TASKS");
export const GENERATE_ALL_TASKS = asyncActionType("GENERATE_ALL_TASKS");

// Scheduled Tasks
export const FETCH_SCHEDULED_TASKS = asyncActionType("FETCH_SCHEDULED_TASKS");
export const FETCH_SCHEDULED_TASK = asyncActionType("FETCH_SCHEDULED_TASK");
export const FETCH_TASK_DASHBOARD = asyncActionType("FETCH_TASK_DASHBOARD");
export const FETCH_TODAY_TASKS = asyncActionType("FETCH_TODAY_TASKS");
export const FETCH_OVERDUE_TASKS = asyncActionType("FETCH_OVERDUE_TASKS");
export const FETCH_UPCOMING_TASKS = asyncActionType("FETCH_UPCOMING_TASKS");
export const START_SCHEDULED_TASK = asyncActionType("START_SCHEDULED_TASK");
export const COMPLETE_SCHEDULED_TASK = asyncActionType("COMPLETE_SCHEDULED_TASK");
export const SKIP_SCHEDULED_TASK = asyncActionType("SKIP_SCHEDULED_TASK");
export const ADD_TASK_PHOTO = asyncActionType("ADD_TASK_PHOTO");

// Maintenance Records
export const FETCH_MAINTENANCE_RECORDS = asyncActionType("FETCH_MAINTENANCE_RECORDS");
export const FETCH_MAINTENANCE_RECORD = asyncActionType("FETCH_MAINTENANCE_RECORD");
export const CREATE_MAINTENANCE_RECORD = asyncActionType("CREATE_MAINTENANCE_RECORD");
export const UPDATE_MAINTENANCE_RECORD = asyncActionType("UPDATE_MAINTENANCE_RECORD");
export const DELETE_MAINTENANCE_RECORD = asyncActionType("DELETE_MAINTENANCE_RECORD");
export const START_MAINTENANCE_RECORD = asyncActionType("START_MAINTENANCE_RECORD");
export const COMPLETE_MAINTENANCE_RECORD = asyncActionType("COMPLETE_MAINTENANCE_RECORD");
export const CANCEL_MAINTENANCE_RECORD = asyncActionType("CANCEL_MAINTENANCE_RECORD");
export const RECORD_SERVICE_VISIT = asyncActionType("RECORD_SERVICE_VISIT");

// Maintenance Photos
export const FETCH_MAINTENANCE_PHOTOS = asyncActionType("FETCH_MAINTENANCE_PHOTOS");
export const UPLOAD_MAINTENANCE_PHOTO = asyncActionType("UPLOAD_MAINTENANCE_PHOTO");
export const DELETE_MAINTENANCE_PHOTO = asyncActionType("DELETE_MAINTENANCE_PHOTO");

// Notifications
export const FETCH_NOTIFICATIONS = asyncActionType("FETCH_MAINTENANCE_NOTIFICATIONS");
export const FETCH_UNREAD_COUNT = asyncActionType("FETCH_UNREAD_COUNT");
export const MARK_NOTIFICATION_READ = asyncActionType("MARK_NOTIFICATION_READ");
export const MARK_ALL_NOTIFICATIONS_READ = asyncActionType("MARK_ALL_NOTIFICATIONS_READ");

// UI State
export const CLEAR_MAINTENANCE_ERROR = "CLEAR_MAINTENANCE_ERROR";
export const SET_ACTIVE_TAB = "SET_MAINTENANCE_ACTIVE_TAB";
export const CLEAR_CURRENT_MACHINE = "CLEAR_CURRENT_MACHINE";
export const CLEAR_CURRENT_RECORD = "CLEAR_CURRENT_RECORD";
export const CLEAR_CURRENT_FACILITY = "CLEAR_CURRENT_FACILITY";
export const CLEAR_CURRENT_TASK = "CLEAR_CURRENT_TASK";
export const CLEAR_CURRENT_TASK_TEMPLATE = "CLEAR_CURRENT_TASK_TEMPLATE";
export const CLEAR_CURRENT_TASK_ASSIGNMENT = "CLEAR_CURRENT_TASK_ASSIGNMENT";
